export default __webpack_public_path__ + "static/media/image_mark.695c017b.svg";